module.exports = __webpack_public_path__ + "static/media/sport-sante.90bc75a1.jpg";